export const az = {
    LEFT: 'Sola: keçid əvvəlki günə.',
    RIGHT: 'Sağa: keçid növbəti günü.',
    DOWN: 'Aşağı: növbəti bar.',
    UP: 'Yuxarı: gedin əvvəlki bar.',
    PGUP: 'Yuxarı: hərəkət əvvəlki aya.',
    PGDOWN: 'PgDown: növbəti ay.',
    HOME: 'Ev: keçid əvvəlki il.',
    END: 'End: köçürə növbəti il üçün.',
    ESC: 'Эку/bu gün/bağlamaq: yaxın təqvim. Təlimat',
    TITLE: 'Klaviatura '
};
